export const IN_CONTEXT_FILE = 'tolgee-in-context-tools.umd.min.js';
export const IN_CONTEXT_UMD_NAME = '@tolgee/in-context-tools';
export const IN_CONTEXT_EXPORT_NAME = 'InContextTools';
